module.exports = __webpack_public_path__ + "assets/img/favicons/apple-icon-180x180.png";